import React, { Component } from 'react';
import PropTypes from 'prop-types';

import LocaleContext from './LocaleContext';
import defaultLocale from './defaultLocale';

class LocaleProvider extends Component {
  render() {
    const { children } = this.props;
    return <LocaleContext.Provider value={defaultLocale}>{children}</LocaleContext.Provider>;
  }
}

LocaleProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]).isRequired
};

export default LocaleProvider;
